var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecurity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3241 2.23006L6.33414 4.10006C5.18414 4.53006 4.24414 5.89006 4.24414 7.12006V14.5501C4.24414 15.7301 5.02415 17.2801 5.97415 17.9901L10.2741 21.2001C11.6841 22.2601 14.0041 22.2601 15.4141 21.2001L19.7141 17.9901C20.6641 17.2801 21.4441 15.7301 21.4441 14.5501V7.12006C21.4441 5.89006 20.5041 4.53006 19.3541 4.10006L14.3641 2.23006C13.5141 1.92006 12.1541 1.92006 11.3241 2.23006Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.834 15.5C15.0431 15.5 16.834 13.7091 16.834 11.5C16.834 9.29086 15.0431 7.5 12.834 7.5C10.6248 7.5 8.83398 9.29086 8.83398 11.5C8.83398 13.7091 10.6248 15.5 12.834 15.5Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.084 10.25V11.18C13.084 11.53 12.904 11.86 12.594 12.04L11.834 12.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurity);
export default __webpack_public_path__ + "static/media/security.bb992f1b7a2e06f400f2571da52d7bb4.svg";
export { ForwardRef as ReactComponent };